import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/aerospace-gvi')({
  component: RouteComponent,
  staticData: {
    title: 'Aerospace GVI',
  },
})

function RouteComponent() {
  return <Outlet />
}
